var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"title":"Detalles GPS Navision","visible":_vm.DriwerVisible,"size":"70%","append-to-body":""},on:{"close":_vm.Onclose}},[_c('el-row',[_c('TableContracts',{ref:"contracts",attrs:{"clientCode":_vm.Cliente}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }